import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getSystemCode } from '@/utils/systemCode';

const spm = {
  // 页面曝光
  pageView: {
    // 抖音1分钱卡活动页页面进入&页面退出
    platform_tt_card() {
      UBT.pageView({
        pageId: 'platform_tt_card',
        categoryId: 'platform',
        businessInfo: {
          spuId: this.spuId,
          cardtype: this.cardType,
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
          abVersion: this.shadowCardSignExperimentName,
        },
      });
    },
    // 支付签约成功页面曝光
    platform_tt_card_finish() {
      UBT.pageView({
        pageId: 'platform_tt_card_finish',
        categoryId: 'platform',
        businessInfo: {
          cardtype: this.cardType,
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
        },
      });
    },
  },
  // 模块曝光
  moduleExpose: {
    // 两轮卡签约完成模块曝光
    platform_tt_card_ridecard_finish() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card_finish',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_ridecard_finish',
        contentId: 'platform_tt_card_ridecard_finish',
        exposureTimes: 1,
        businessInfo: {
          card_guid: this.cardGuid,
          adsource: this.adsource,
          systemcode: getSystemCode(),
          productTagForDySign: this.productTagForDySign,
        },
      });
    },
    // 两轮卡guid激活模块曝光
    platform_tt_card_ridecard() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_ridecard',
        contentId: 'platform_tt_card_ridecard',
        exposureTimes: 1,
        businessInfo: {
          adsource: this.adsource,
          systemcode: getSystemCode(),
          card_guid: this.cardGuid,
          productTagForDySign: this.productTagForDySign,
        },
      });
    },
    // 连续包月模块模块曝光
    platform_tt_card_monthly() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_monthly',
        contentId: 'platform_tt_card_monthly',
        exposureTimes: 1,
        businessInfo: {
          spuId: this.spuId,
          adsource: this.adsource,
          systemcode: getSystemCode(),
          cardtype: this.cardType,
          productTagForDySign: this.productTagForDySign,
        },
      });
    },
    // 影子卡支付激活按钮模块曝光
    platform_tt_card_activate_pay() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_activate_pay',
        contentId: 'platform_tt_card_activate_pay',
        exposureTimes: 1,
        businessInfo: {
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
          abVersion: this.shadowCardSignExperimentName,
        },
      });
    },
    // 影子卡激活按钮模块曝光
    platform_tt_card_activate() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_activate',
        contentId: 'platform_tt_card_activate',
        exposureTimes: 1,
        businessInfo: {
          cardtype: this.cardType,
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
          abVersion: this.shadowCardSignExperimentName,
        },
      });
    },
    // 升级连续包月卡模块模块曝光
    platform_tt_card_monthlyUpdate() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_monthlyUpdate',
        contentId: 'platform_tt_card_monthlyUpdate',
        exposureTimes: 1,
        businessInfo: {
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
          systemcode: getSystemCode(),
          adsource: this.adsource,
          spuId: this.spuId,
        },
      });
    },
    // 升级连续包月模块-左侧影子卡模块模块曝光
    platform_tt_card_monthlyUpdate_shadow() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_monthlyUpdate_shadow',
        contentId: 'platform_tt_card_monthlyUpdate_shadow',
        exposureTimes: 1,
        businessInfo: {
          cardtype: this.cardType,
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
          abVersion: this.shadowCardSignExperimentName,
        },
      });
    },
    // 连续包月升级弹窗模块曝光
    platform_tt_card_toupdate() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_toupdate',
        contentId: 'platform_tt_card_toupdate',
        exposureTimes: 1,
        businessInfo: {
          adsource: this.adsource,
          systemcode: getSystemCode(),
        },
      });
    },
    // 连续包月协议确认模块曝光
    platform_tt_card_monthly_confirm() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_monthly_confirm',
        contentId: 'platform_tt_card_monthly_confirm',
        exposureTimes: 1,
        businessInfo: {
          spuId: this.spuId,
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
        },
      });
    },
    // 支付并签约成功模块曝光
    platform_tt_card_finish_paid() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card_finish',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_finish_paid',
        contentId: 'platform_tt_card_finish_paid',
        exposureTimes: 1,
        businessInfo: {
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
          systemcode: getSystemCode(),
        },
      });
    },
    //  影子卡激活成功模块曝光
    platform_tt_card_finish_activate() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card_finish',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_finish_activate',
        contentId: 'platform_tt_card_finish_activate',
        exposureTimes: 1,
        businessInfo: {
          cardtype: this.cardType,
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
          abVersion: this.shadowCardSignExperimentName,
        },
      });
    },
    // 连续包月升级下-影子卡激活成功模块曝光
    platform_tt_card_finish_monthlyUpdate_shadowcard() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card_finish',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_finish_monthlyUpdate_shadowcard',
        contentId: 'platform_tt_card_finish_monthlyUpdate_shadowcard',
        exposureTimes: 1,
        businessInfo: {
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          abVersion: this.shadowCardSignExperimentName,
        },
      });
    },
    //  影子卡激活成功模块曝光
    platform_tt_card_finish_activate_pay() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card_finish',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_finish_activate_pay',
        contentId: 'platform_tt_card_finish_activate_pay',
        exposureTimes: 1,
        businessInfo: {
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
          abVersion: this.shadowCardSignExperimentName,
        },
      });
    },
    // 单独购买一个月成功模块曝光
    platform_tt_card_finish_monthlySinglePaid() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card_finish',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_finish_monthlySinglePaid',
        contentId: 'platform_tt_card_finish_monthlySinglePaid',
        exposureTimes: 1,
        businessInfo: {
          systemcode: getSystemCode(),
          cardtype: this.cardType,
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
        },
      });
    },
    // 连续包月成功模块曝光
    platform_tt_card_finish_monthlyPaid() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card_finish',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_finish_monthlyPaid',
        contentId: 'platform_tt_card_finish_monthlyPaid',
        exposureTimes: 1,
        businessInfo: {
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
          systemcode: getSystemCode(),
        },
      });
    },
    // 升级连续包月支付签约完成模块曝光
    platform_tt_card_finish_monthlyUpdate() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card_finish',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_finish_monthlyUpdate',
        contentId: 'platform_tt_card_finish_monthlyUpdate',
        exposureTimes: 1,
        businessInfo: {
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
        },
      });
    },
    // 离开页面挽留弹窗模块曝光
    platform_tt_card_retention() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_retention',
        contentId: 'platform_tt_card_retention',
        exposureTimes: 1,
        businessInfo: {
          abVersion: this.experimentId,
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
        },
      });
    },
    // 不补贴复购页面购卡优惠曝光
    platform_tt_card_noSubsidyRepurchase_discount() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_repurchase',
        contentId: 'platform_tt_card_repurchase',
        exposureTimes: 1,
        businessInfo: {
          spuId: this.reportSpuId,
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
        },
      });
    },
    // 不补贴复购页面购卡支付成功曝光
    platform_tt_card_noSubsidyRepurchase_pay_success() {
      UBT.moduleExpose({
        pageId: 'platform_tt_card_finish',
        categoryId: 'platform',
        moduleId: 'platform_tt_card_finish_repurchase',
        contentId: 'platform_tt_card_finish_repurchase',
        exposureTimes: 1,
        businessInfo: {
          spuId: this.reportSpuId,
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
        },
      });
    },
  },
  // 模块点击
  clickButton: {
    // 两轮卡guid激活模块点击
    platform_tt_card_ridecard() {
      UBT.clickButton({
        pageId: 'platform_tt_card',
        buttonName: 'platform_tt_card_ridecard',
        categoryId: 'platform',
        businessInfo: {
          adsource: this.adsource,
          systemcode: getSystemCode(),
          card_guid: this.cardGuid,
          productTagForDySign: this.productTagForDySign,
        },
      });
    },
    // 两轮卡签约完成模块点击
    platform_tt_card_ridecard_finish() {
      UBT.clickButton({
        pageId: 'platform_tt_card_finish',
        buttonName: 'platform_tt_card_ridecard_finish',
        categoryId: 'platform',
        businessInfo: {
          card_guid: this.cardGuid,
          adsource: this.adsource,
          systemcode: getSystemCode(),
          productTagForDySign: this.productTagForDySign,
        },
      });
    },
    platform_tt_card_finish_back() {
      UBT.clickButton({
        pageId: 'platform_tt_card_finish',
        buttonName: 'platform_tt_card_finish_back',
        categoryId: 'platform',
        businessInfo: {
          cardtype: this.cardType,
          adsource: this.adsource,
          systemcode: getSystemCode(),
        },
      });
    },
    // 影子卡支付激活按钮模块点击
    platform_tt_card_activate_pay() {
      UBT.clickButton({
        pageId: 'platform_tt_card',
        buttonName: 'platform_tt_card_activate_pay',
        categoryId: 'platform',
        businessInfo: {
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
          abVersion: this.shadowCardSignExperimentName,
        },
      });
    },
    // 影子卡激活按钮模块点击
    platform_tt_card_activate(errorCode) {
      UBT.clickButton({
        pageId: 'platform_tt_card',
        buttonName: 'platform_tt_card_activate',
        categoryId: 'platform',
        businessInfo: {
          abVersion: this.shadowCardSignExperimentName,
          cardtype: this.cardType,
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
          errorCode, // 点击激活，errorCode传0
        },
      });
    },
    // 连续包月模块商品模块点击
    platform_tt_card_monthly(position) {
      UBT.clickButton({
        pageId: 'platform_tt_card',
        buttonName: 'platform_tt_card_monthly',
        categoryId: 'platform',
        businessInfo: {
          spuId: this.spuId,
          adsource: this.adsource,
          systemcode: getSystemCode(),
          cardtype: this.cardType,
          productTagForDySign: this.productTagForDySign,
          position,
        },
      });
    },
    // 升级连续包月卡模块模块点击
    platform_tt_card_monthlyUpdate_shadow() {
      UBT.clickButton({
        pageId: 'platform_tt_card',
        buttonName: 'platform_tt_card_monthlyUpdate_shadow',
        categoryId: 'platform',
        businessInfo: {
          cardtype: this.cardType,
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
        },
      });
    },
    platform_tt_card_monthlyUpdate() {
      UBT.clickButton({
        pageId: 'platform_tt_card',
        buttonName: 'platform_tt_card_monthlyUpdate',
        categoryId: 'platform',
        businessInfo: {
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
          systemcode: getSystemCode(),
          adsource: this.adsource,
          spuId: this.spuId,
        },
      });
    },
    // 连续包月升级弹窗模块点击
    platform_tt_card_toupdate() {
      UBT.clickButton({
        pageId: 'platform_tt_card',
        buttonName: 'platform_tt_card_toupdate',
        categoryId: 'platform',
        businessInfo: {
          adsource: this.adsource,
          systemcode: getSystemCode(),
        },
      });
    },
    // 连续包月协议确认模块点击
    platform_tt_card_monthly_confirm() {
      UBT.clickButton({
        pageId: 'platform_tt_card',
        buttonName: 'platform_tt_card_monthly_confirm',
        categoryId: 'platform',
        businessInfo: {
          spuId: this.spuId,
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
        },
      });
    },
    // 去使用按钮点击
    platform_tt_card_finish_buttun() {
      UBT.clickButton({
        pageId: 'platform_tt_card_finish',
        buttonName: 'platform_tt_card_finish_buttun',
        categoryId: 'platform',
        businessInfo: {
          cardtype: this.cardType,
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
        },
      });
    },
    // 影子卡激活成功-支付模块点击
    platform_tt_card_finish_activate_pay() {
      UBT.clickButton({
        pageId: 'platform_tt_card_finish',
        buttonName: 'platform_tt_card_finish_activate_pay',
        categoryId: 'platform',
        businessInfo: {
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
          abVersion: this.shadowCardSignExperimentName,
        },
      });
    },
    // 升级连续包月支付签约完成模块点击
    platform_tt_card_finish_monthlyUpdate() {
      UBT.clickButton({
        pageId: 'platform_tt_card_finish',
        buttonName: 'platform_tt_card_finish_monthlyUpdate',
        categoryId: 'platform',
        businessInfo: {
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
        },
      });
    },
    // 连续包月升级下-影子卡激活成功模块点击
    platform_tt_card_finish_monthlyUpdate_shadowcard() {
      UBT.clickButton({
        pageId: 'platform_tt_card_finish',
        buttonName: 'platform_tt_card_finish_monthlyUpdate_shadowcard',
        categoryId: 'platform',
        businessInfo: {
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          abVersion: this.shadowCardSignExperimentName,
        },
      });
    },
    // 支付签约模块点击
    platform_tt_card_gott() {
      UBT.clickButton({
        pageId: 'platform_tt_card',
        buttonName: 'platform_tt_card_gott',
        categoryId: 'platform',
        businessInfo: {
          cardtype: this.cardType,
          productTagForDySign: this.productTagForDySign,
          adsource: this.adsource,
          systemcode: getSystemCode(),
        },
      });
    },
    // 离开页面挽留弹窗 残忍离开按钮模块点击
    platform_tt_card_retention(buttunName) {
      UBT.clickButton({
        pageId: 'platform_tt_card',
        buttonName: 'platform_tt_card_retention',
        categoryId: 'platform',
        businessInfo: {
          buttunName,
          abVersion: this.experimentId,
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
        },
      });
    },
    // 不补贴复购页面购卡支付成功模块点击
    platform_tt_card_noSubsidyRepurchase_pay_success() {
      UBT.clickButton({
        pageId: 'platform_tt_card_finish',
        buttonName: 'platform_tt_card_finish_repurchase',
        categoryId: 'platform',
        businessInfo: {
          spuId: this.reportSpuId,
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
        },
      });
    },
    // 不补贴复购页面购卡优惠模块点击
    platform_tt_card_noSubsidyRepurchase_discount() {
      UBT.clickButton({
        pageId: 'platform_tt_card',
        buttonName: 'platform_tt_card_repurchase',
        categoryId: 'platform',
        businessInfo: {
          spuId: this.reportSpuId,
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: this.productTagForDySign,
          cardtype: this.cardType,
        },
      });
    },
  },
};

export default spm;
